import React from 'react'
import PayableSite from '../../../features/account-payable/account-payable-site'

function AccountPayable() {
  return (
    <PayableSite />
  )
}

export default AccountPayable